export default __webpack_public_path__ + "static/media/element.46b87119.png";